import React from 'react';
import { Select } from 'antd';
import { type CategoryOptions } from './utils';

interface Props {
  id?: string;
  value?: string;
  categoryOptions: CategoryOptions;
  onChange?: (value: string) => void;
}

const Category = (props: Props) => {
  const { id, value, categoryOptions, onChange } = props;

  return (
    <div id={id}>
      <Select
        showSearch
        style={{
          width: '300px',
        }}
        value={value}
        options={categoryOptions}
        onChange={(data) => {
          onChange?.(data);
        }}
      />
    </div>
  );
};

export default React.memo(Category);
